import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemPieComponent } from '../../components/item-pie/item-pie.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { LoaderBlocksComponent } from '../../components/loader-blocks/loader-blocks.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import ServiceRestServices from '../../services/service-rest.service';
import Browser from '../../utils/browser.service';
import UserService from '../../services/user.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'modal-booking-instant-status',
	templateUrl: './modal-booking-instant-status.component.html',
	imports: [ CommonModule, TranslatePipe, ItemPieComponent, LoaderOverlayComponent, LoaderBlocksComponent, FormsModule ]
})
export class ModalBookingInstantStatusComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private browser: Browser = inject(Browser);
	private userService: UserService = inject(UserService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private dialogRef = inject(MatDialogRef<ModalBookingInstantStatusComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.thirdPartyRenewal = window.sessionStorage.getItem("THIRD_PARTY_RENEWAL");
		this.vm.cancellationPeriodInSeconds = 20;
		this.vm.isCancellationRequested = false;
		
		this.vm.localConfig = {
			acceptedRedirectDelay: 10000,
			pendingTimerInterval: 1000,
			statusPollInterval: 10000
		};
		this.vm.browser = this.browser.getBrowser();
		this.vm.isIE = this.vm.browser === 'ie';
		this.handleComponentInit();
		
		var eventName = this.config.getBroadcastConfig().Instant_Bookings.STATUS_CHANGED;
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, eventName, (e, newStatus) => {
				this.vm.status = newStatus;
				this.handleComponentInit();
			})
		);
		
		this.vm.handleRedirectHome = this.handleRedirectHome;
		this.vm.handleRefundInit = this.handleRefundInit;
		this.vm.handleRequestCancel = this.handleRequestCancel;
	}
	
	ngOnDestroy() {
		if (this.vm.pendingTimerListener) {
			this.angularHelperService.cancelInterval(this.vm.pendingTimerListener);
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	handleComponentInit() {
		this.handlePendingTimerDestroy();
		this.handleStatusTimerDestroy();
		this.handleRedirectTimerDestroy();
		
		switch (this.vm.status) {
			case 'pending':
			{
				this.vm.startedAt = undefined;
				
				var localStartedAt = undefined;
				this.vm.pendingTimerListener = this.angularHelperService.createInterval(() => {
					if (this.vm.startedAt !== undefined || !this.angularHelperService.equals(this.vm.startedAt, localStartedAt)) {
						localStartedAt = this.vm.startedAt;
						this.angularHelperService.cancelInterval(this.vm.pendingTimerListener);
						this.handlePendingTimerInit();
					}
				}, 200);

				this.handleStatusTimerInit();
				break;
			}
			case 'accepted':
			{
				this.handleRedirectTimerInit();
				break;
			}
			default:
			return;
		}
	}
	
	handleRedirectHome() {
		this.handlePendingTimerDestroy();
		this.handleStatusTimerDestroy();
		this.handleRedirectTimerDestroy();
		this.userService.clearWalletCache();
		this.dialogRef.close();
		if (this.vm.thirdPartyRenewal === 'benu' && !this.vm.isCancellationRequested) {
			this.angularRoutingHelperService.setPath('/benu/thank-you');
		} else {
			this.angularRoutingHelperService.goHomeAndKeepHistory(this.session.getSession().user);
		}
	}
	
	handleRefundInit() {
		if (this.vm.processing) return;
		this.vm.processing = true;
		
		this.serviceRestServices.setInstantBookingStatus({ bookingId: this.vm.bookingId, status: 'refund' }, {}, (res) => {
			this.handleRedirectHome();
		}, (err) => {
			console.error(err);
			this.vm.processing = false;
		});
	}
	
	handleRequestCancel() {
		this.vm.isCancellationRequested = true;
		if (this.vm.cancellationPeriodInSeconds > 0) {
			return;
		}
		this.serviceRestServices.setInstantBookingStatus({ bookingId: this.vm.bookingId, status: 'cancel' }, {}, (res) => {
			this.handlePendingTimerDestroy();
			this.handleStatusTimerDestroy();
			this.handleRedirectTimerDestroy();
			this.vm.status = 'cancel';
		}, (err) => {
			console.error(err);
		});
	}
	
	handleRedirectTimerInit() {
		this.handleRedirectTimerDestroy();
		this.vm.redirectTimer = this.angularHelperService.createTimer(() => {
			this.handleRedirectHome();
		}, this.vm.localConfig.acceptedRedirectDelay);
	}
	
	handleRedirectTimerDestroy() {
		if (this.vm.redirectTimer) this.angularHelperService.cancelTimer(this.vm.redirectTimer);
	}
	
	handleStatusUpdate() {
		this.serviceRestServices.getInstantBookingStatus({ bookingId: this.vm.bookingId }, (res) => {
			this.vm.startedAt = new Date(res.modified);
			this.vm.isPrescription = res.type === 'PRESCRIPTION_REQUEST';
			var newStatus: any = res.status.toLowerCase();
			
			if (this.vm.status !== newStatus) {
				this.vm.status = newStatus;
				
				var path: any = '/booking/instant/' + this.vm.bookingId + '/' + newStatus;
				this.angularRoutingHelperService.setPath(path, false, true);
				
				this.handleComponentInit();
			}
		}, (err) => {
			console.error(err);
		});
	}
	
	handleStatusTimerInit() {
		this.handleStatusUpdate();
		this.handleStatusTimerDestroy();
		this.vm.statusInterval = this.angularHelperService.createTimer(() => {
			this.handleStatusTimerInit();
		}, this.vm.localConfig.statusPollInterval);
	}
	
	handleStatusTimerDestroy() {
		if (this.vm.statusInterval) this.angularHelperService.cancelTimer(this.vm.statusInterval);
	}
	
	handlePendingTimerUpdate() {
		var currentDate: any = moment();
		var startDate: any = this.vm.startedAt ? moment(this.vm.startedAt) : currentDate;
		var diff: any = startDate.add(this.config.getBookingConfig().Instant.SECONDS_PENDING, 'seconds').diff(currentDate);
		var duration: any = moment.duration(diff, 'milliseconds');
		
		if (this.vm.cancellationPeriodInSeconds > 0) {
			this.vm.cancellationPeriodInSeconds--;
		}
		
		if (duration.asMilliseconds() <= 0) {
			this.handleRequestExpiry();
		} else {
			var minutes: any = Math.floor(duration.asMinutes());
			var seconds: any = Math.floor(duration.asSeconds()) - minutes * 60;
			this.vm.timeLeft = minutes + ':' + ('0' + seconds).slice(-2);
			var timeUsed = (this.config.getBookingConfig().Instant.SECONDS_PENDING - Math.floor(duration.asSeconds()));
			this.vm.timePercentage = timeUsed / this.config.getBookingConfig().Instant.SECONDS_PENDING * 100;
		}
	}
	
	handlePendingTimerInit() {
		this.handlePendingTimerUpdate();
		this.handlePendingTimerDestroy();
		this.vm.pendingTimer = this.angularHelperService.createTimer(() => {
			this.handlePendingTimerInit();
		}, this.vm.localConfig.pendingTimerInterval);
	}
	
	handlePendingTimerDestroy() {
		if (this.vm.pendingTimer) this.angularHelperService.cancelTimer(this.vm.pendingTimer);
	}
	
	handleRequestExpiry() {
		var expiredStatus: any = 'timeout';
		this.serviceRestServices.setInstantBookingStatus({ bookingId: this.vm.bookingId, status: expiredStatus }, {},
			(res) => {
				this.vm.status = res.status.toLowerCase();;

				var path: any = '/booking/instant/' + this.vm.bookingId + '/' + this.vm.status;
				this.angularRoutingHelperService.setPath(path, false, true);

				this.handleComponentInit();
			},
			(err) => {
				console.error(err);
			}
		);
	}
	
}